import { EListingOffersActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const markListingEmpty = actionGenerator<EListingOffersActionType.MarkEmpty>(EListingOffersActionType.MarkEmpty);
